import React from 'react';

import { CoreIcon } from '@aspid/ui';
import { IconButton } from '@mui/material';

import { IconCollection } from '@components/icons/iconCollection';

import type { ExternalLinkIconButtonProperties } from './ExternalLinkIconButton.types';

export const ExternalLinkIconButton: React.FC<ExternalLinkIconButtonProperties> = ({
  href = '',
  dataTest = 'external_link_icon_button',
  sx,
}) => (
  <IconButton
    data-testid={dataTest}
    size='small'
    href={href}
    target='_blank'
    aria-label='open link'
    sx={{ p: 0.5, ...sx }}
  >
    <CoreIcon
      icon={IconCollection.arrowUpRightFromSquare}
      sx={{ fontSize: 14, cursor: 'pointer' }}
      color='action'
    />
  </IconButton>
);
